module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        'active': _vm.name === tab.id,
        'tab-active': _vm.tabActivePill
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.setTab(tab.pathName)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])])
  }))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93ecb92e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/components/nav.vue
// module id = 1813
// module chunks = 180